import React, { useContext, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { Grid } from "@material-ui/core"
import GridHeader from "components/common/GridHeader"
import InventoryInteractionsTable from "components/Inventory/InventoryInteractionsTable"
import { ReducerContext } from "App"

const InventoryInteractions = () => {
  const { state: { user: { permissions } } } = useContext(ReducerContext)
  const history = useHistory()

  useEffect(() => { !permissions.includes('user') && history.push("/unauthorized") }, [permissions, history])

  return (
    <Grid container className="GridContainer">
      <GridHeader h4="Inventory Interactions List" p="Masterview for recent Inventory Interactions.">
        <InventoryInteractionsTable />
      </GridHeader>
    </Grid>
  )
}

export default InventoryInteractions
